<template>
  <div></div>
</template>

<script>
export default {
  name: "NotificationsDialog"
}
</script>

<style lang="scss" scoped>
</style>